import {
    ACCOUNTS_ARE_LOADING, ACCOUNTS_FETCH_ERROR,
    ACCOUNTS_HAVE_LOADED, SECURITY_PROFILE_LOADED, USER_IS_LOADING,
    USER_SIGNED_IN,
    USER_SIGNED_OUT, USER_SUBMITTED_FEEDBACK, USER_SUBMITTED_SECURITY
} from "./actions";
import {combineReducers} from "redux";

export const NO_ERROR = false;

/*
 * Reducers and State go hand in hand. Based on the type of action invoked (see actions.js),
 * reducers are used to alter the 'state' of the redux store. These states are then mapped
 * back to the react components (via 'mapStateToProps' methods) so that if ever the mapped
 * state changes, then the react component re renders.
 *
 * That is how reducers/states are an integral part of the react/redux framework.
 *
 * Also, the state of the app across each user action/event can be written to a remote logging
 * service. I plan to do such, which will help me debug if any app issues are encountered.
 */

const initState = {
    user: {},
    isAuthenticated: false,
    userIsLoading: false,
    accounts: [],
    accountsLoading: false,
    accountsError: NO_ERROR,
    feedbackRecordedMessage: '',
    userSecurityProfile: {}
};

const userReducer = (state = initState.user, action) => {
    switch (action.type) {
        case USER_SIGNED_IN:
            return action.user;
        case USER_SIGNED_OUT:
            return {};
        default:
            return state;
    }
};

const userIsLoadingReducer = (state = initState.userIsLoading, action) => {
    switch (action.type) {
        case USER_IS_LOADING:
            return action.val;
        default:
            return state;
    }
};

const authenticatedReducer = (state = initState.isAuthenticated, action) => {
    switch (action.type) {
        case USER_SIGNED_IN:
            return true;
        case USER_SIGNED_OUT:
            return false;
        default:
            return state;
    }
};

const accountsLoadedReducer = (state = initState.accounts, action) => {
    switch (action.type) {
        case ACCOUNTS_HAVE_LOADED:
            return action.accounts;
        default:
            return state;

    }
};

const accountsLoadingReducer = (state = initState.accountsLoading, action) => {
    switch (action.type) {
        case ACCOUNTS_ARE_LOADING:
            return true;
        case ACCOUNTS_HAVE_LOADED:
            return false;
        case ACCOUNTS_FETCH_ERROR:
            return false;
        default:
            return state;
    }
};

const accountsErrorReducer = (state = initState.accountsError, action) => {
    switch (action.type) {
        case ACCOUNTS_FETCH_ERROR:
            return action.err;
        default:
            return state;
    }
};

const feedbackSubmissionMessageReducer = (state = initState.feedbackRecordedMessage, action) => {
  switch (action.type) {
      case USER_SUBMITTED_FEEDBACK:
          return action.recordedMsg;
      default:
          return state;
  }
};

const securityProfileReducer = (state = initState.userSecurityProfile, action) => {
    switch (action.type) {
        case USER_SUBMITTED_SECURITY:
        case SECURITY_PROFILE_LOADED:
            return action.securityProfile;
        default:
            return state;
    }
};

const rootReducer = combineReducers({
    user: userReducer,
    isAuthenticated: authenticatedReducer,
    accounts: accountsLoadedReducer,
    accountsLoading: accountsLoadingReducer,
    accountsError: accountsErrorReducer,
    feedbackRecordedMessage: feedbackSubmissionMessageReducer,
    userIsLoading: userIsLoadingReducer,
    userSecurityProfile: securityProfileReducer
});

export default rootReducer;